export default {
  GET: {
    REQUEST: 'REQUEST_ME',
    RECEIVE: 'RECEIVE_ME',
    FAIL: 'FAIL_ME'
  },
  INVALIDATE: 'INVALIDATE_ME'
}
